import { createContext } from "react";

interface ToastContextInterface {
  addToast: (content: string) => void;
  removeToast: (id: number) => void;
}

const ToastContext = createContext<ToastContextInterface>({
  addToast: (content) => {},
  removeToast: (id) => {},
});

export default ToastContext;
